import Header from "../Header/Header";
import {Drawer} from "@mui/material";
import RightMenu from "../RightMenu";
import React, {useEffect, useState} from "react";
import * as Constants from "../../constants/urls";
import axios from "axios";
import {useCookies} from "react-cookie";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
 
export function ShippingForm(props) {
    const [state, setState] = React.useState({right: false});
    const [packs, setPacks] = useState(undefined);
    const [modal, setModal] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies();

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({...state, [anchor]: open});
    };
    useEffect(() => {

        const url = Constants.apiUrl + "/api/packs/paginate";
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setPacks(r.data);
            })
            .catch((e) => {

            });
    }, []);
    return (
        <>
                  <Breadcrumb title={"ارسال غیر رایگان"} />

            <div className="container bg- text-center rtl border rounded py-2 px-0 mt-5">

                <div className="row">
                    <div className="col">
                    <div className="btn btn-danger" onClick={props.modal}> انتخاب بسته</div>
                        <br/>
                    <label className={"text-primary mt-3"}>شناسه بسته : {props.packId}</label><br/>
                    </div>
                </div>
<hr/>
                <div className="row">
                    <div className="col">
                    <label htmlFor="status">فعال</label>
                    <input type="checkbox" id="status" className="form-controll mx-2" value={props.status}
                           checked={props.status == 1 ? "checked" : false} onChange={props.changeStatus}/>
                </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col">
                    <div className="btn btn-block btn-danger"
                         onClick={props.action}>{props.type == "create" ? "ایجاد" : "ویرایش"}</div>
                </div>
            </div>
            </div>
        </>
    )
}
